import React, { useMemo } from "react";

// Soft flower/petal fall - subtle & dignified. Uses CSS keyframe animate-petal-fall.
const FloatingPetals = ({ count = 14 }) => {
  const petals = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const left = Math.random() * 100;
        const dur = 14 + Math.random() * 16;
        const delay = -Math.random() * 20;
        const size = 8 + Math.random() * 10;
        const opacity = 0.25 + Math.random() * 0.35;
        const hue = ["#556B2F", "#6B8E23", "#4A6B2A", "#7A9C3F", "#3F5E1E"][Math.floor(Math.random() * 5)];
        return { i, left, dur, delay, size, opacity, hue };
      }),
    [count]
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {petals.map((p) => (
        <svg
          key={p.i}
          className="absolute animate-petal-fall"
          style={{
            left: `${p.left}%`,
            top: 0,
            animationDuration: `${p.dur}s`,
            animationDelay: `${p.delay}s`,
            opacity: p.opacity,
          }}
          width={p.size}
          height={p.size * 1.4}
          viewBox="0 0 10 14"
        >
          <path d="M5 0 C 8 4, 8 10, 5 14 C 2 10, 2 4, 5 0 Z" fill={p.hue} />
        </svg>
      ))}
    </div>
  );
};

export default FloatingPetals;
